/**
 * TrialChargeNotice - Fine print explaining trial charges
 *
 * Displays text explaining when the user will be charged after their trial ends.
 * Shows discounted first charge price when a coupon is applied.
 */

interface TrialChargeNoticeProps {
  /** Annual price in dollars (regular price) */
  annualPrice?: number;
  /** Discounted first charge in dollars (when coupon applied) */
  discountedFirstCharge?: number;
  /** Optional className for custom styling */
  className?: string;
}

export function TrialChargeNotice({
  annualPrice = 119,
  discountedFirstCharge,
  className = '',
}: TrialChargeNoticeProps) {
  // Show discounted price if a coupon is applied and the first charge is different
  const hasDiscount = discountedFirstCharge !== undefined && discountedFirstCharge < annualPrice;

  if (hasDiscount) {
    return (
      <p className={`text-center text-xs text-slate-500 ${className}`}>
        After your 7-day free trial, you&apos;ll be charged{' '}
        <span className="font-medium text-green-600">${discountedFirstCharge}</span>{' '}
        <span className="line-through">${annualPrice}</span> for your first year,
        then ${annualPrice}/year.
      </p>
    );
  }

  return (
    <p className={`text-center text-xs text-slate-500 ${className}`}>
      After your 7-day free trial, you&apos;ll be charged ${annualPrice}{' '}
      annually.
    </p>
  );
}

export default TrialChargeNotice;
